/**
 * Holds the names of the individual characteristic filter arrays for simple filter mode as they are called in the store.
 */
export enum SimpleCharacteristicFilterNameInStore {
  Condition = 'conditionFilters',
  Uicc = 'uiccFilters',
  Intervention = 'interventionFilters',
  Tmb = 'tmbFilters',
  Subtype = 'subtypeFilters',
  Biomarker = 'biomarkerFilters',
  TumorEntity = 'tumorentityFilters',
  TumorRegion = 'tumorregionFilters',
  TumorCategory = 'tumorcategoryFilters',
  Pathway = 'pathwayFilters',
  LineOfTherapy = 'lineOfTherapyFilters',
  MutatedGene = 'mutatedFilters',
  WildtypeGene = 'wildtypeFilters',
  Adjuvant = 'adjuvantFilters',
  Variant = 'proteinChangeFilters',
}
